import { Component } from '@angular/core';
import { CurrentUser } from '@models/Core/CurrentUser';
import { AuthenticationRequestService } from '@services/auth/authentication.request.service';
import { AuthenticationService } from '@services/auth/authentication.service';
import _ from 'lodash';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent {
  user: CurrentUser;
  original: CurrentUser;
  activeUpload = false;

  constructor(
    private auth: AuthenticationService,
    private backend: AuthenticationRequestService,
  ) {
    this.auth.getCurrentUser.subscribe(user => {
      _.defaultsDeep(user, {
        first_name: '',
        organization: '',
        department: '',
        occupation: '',
        location: {
          city: '',
          country: '',
          zipcode: '',
        },
        visibility: {
          email: false,
          department: true,
          occupation: true,
          location: {
            city: true,
            country: true,
            zipcode: true,
          },
        },
        emailSettings: {
          userAddedAsCollaborator: true,
          userInvitedAsCollaborator: true,
          someoneAddedAsCollaborator: true,
          someoneCommented: true,
          someoneRequestedCollaboration: true,
          directMessage: true,
        },
      });

      this.original = user;
      this.user = _.cloneDeep(user);
    });
  }

  get saveLabel() {
    if (this.activeUpload) {
      return 'Uploading ...';
    } else if (!this.valid) {
      return 'Invalid Info';
    } else if (!this.changed) {
      return 'Saved';
    } else {
      return 'Save';
    }
  }

  save() {
    this.backend.update(this.user).subscribe(() => {
      _.extend(this.original, this.user);
      this.user = _.cloneDeep(this.original);
    });
  }

  get changed(): boolean {
    return !_.isEqual(
      _.omit(this.user, ['emailSettings']),
      _.omit(this.original, ['emailSettings']),
    );
  }

  get notifChanged(): boolean {
    return !_.isEqual(
      _.pick(this.user, ['emailSettings']),
      _.pick(this.original, ['emailSettings']),
    );
  }

  upload(key) {
    this.user.profile_picture = key;
    this.activeUpload = false;
  }

  get valid(): boolean {
    return (
      !!this.user.name &&
      !!this.user.email &&
      (!!this.user.first_name || !this.original.first_name)
      //      && (!!this.user.organization || !this.original.organization)
      //      && (!!this.user.department || !this.original.department)
      //      && (!!this.user.occupation || !this.original.occupation)
      //      && (!!this.user.location.zipcode || !this.original.location.zipcode)
      //      && (!!this.user.location.city || !this.original.location.city)
      //      && (!!this.user.location.country || !this.original.location.country)
    );
  }
}
